var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a, _b, _c, _d, _e, _f, _g, _h;
import { action, computed, observable, ObservableMap, reaction, makeObservable } from 'mobx';
import { default as exportConfigsStore } from './ExportConfigsStore';
import { BackgroundImage, BackgroundImageType, ExportConfig } from '../services/ImageExportConfigsApi';
import { DEFAULT_IMAGE_CODES, isDefaultPosition } from '../framework/constants/exportConfig';
class ExportConfigEditorStore {
    /* eslint-disable indent,@typescript-eslint/indent */
    constructor(exportConfigsStore) {
        Object.defineProperty(this, "exportConfigsStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "exportConfig", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "wallImage", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "floorImage", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "watermarkImage", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "autoDeWatermarkImage", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "imageType", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'default'
        });
        Object.defineProperty(this, "isDefaultOrder", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: true
        });
        Object.defineProperty(this, "watermark", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "customPositionsByImageCodes", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: observable.map([], { deep: false })
        });
        Object.defineProperty(this, "setExportConfig", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (exportConfig) => {
                this.exportConfig = exportConfig;
            }
        });
        Object.defineProperty(this, "setGeneral", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (isGeneral) => {
                this.isGeneral = isGeneral;
            }
        });
        Object.defineProperty(this, "setDefaultOrder", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (isDefaultOrder) => {
                this.isDefaultOrder = isDefaultOrder;
            }
        });
        Object.defineProperty(this, "setWatermark", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (watermark) => {
                this.watermark = watermark;
            }
        });
        Object.defineProperty(this, "setAutoDeWatermark", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (autoDeWatermark) => {
                this.autoDeWatermark = autoDeWatermark;
            }
        });
        Object.defineProperty(this, "setImageType", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (type) => {
                this.imageType = type;
            }
        });
        Object.defineProperty(this, "setImage", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (image) => {
                const { appointment } = image;
                switch (appointment) {
                    case 'wall':
                        this.wallImage = image;
                        break;
                    case 'floor':
                        this.floorImage = image;
                        break;
                    case 'watermark':
                        this.watermarkImage = image;
                        break;
                    case 'auto_de_watermark':
                        this.autoDeWatermarkImage = image;
                        break;
                    default:
                }
            }
        });
        Object.defineProperty(this, "removeImage", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (image) => {
                const { appointment, id } = image;
                switch (appointment) {
                    case 'wall':
                        if (this.wallImage.id === id)
                            this.wallImage = null;
                        break;
                    case 'floor':
                        if (this.floorImage.id === id)
                            this.floorImage = null;
                        break;
                    case 'watermark':
                        if (this.watermarkImage.id === id)
                            this.watermarkImage = null;
                        break;
                    case 'auto_de_watermark':
                        if (this.autoDeWatermarkImage.id === id)
                            this.autoDeWatermarkImage = null;
                        break;
                    default:
                }
            }
        });
        Object.defineProperty(this, "addImageCodePosition", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (imageCode, position) => {
                const oldImageCode = this.customSortedImageCodes[position];
                if (this.customPositionsByImageCodes.has(oldImageCode)) {
                    this.customPositionsByImageCodes.delete(oldImageCode);
                }
                this.customPositionsByImageCodes.set(imageCode, position);
            }
        });
        Object.defineProperty(this, "replaceImageCodePosition", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (oldPosition, newPosition) => {
                const customSortedImageCodes = this.customSortedImageCodes;
                const offset = Math.sign(oldPosition - newPosition);
                let position = newPosition;
                while (this.customPositionsByImageCodes.has(customSortedImageCodes[position]) && position !== oldPosition) {
                    this.customPositionsByImageCodes.set(customSortedImageCodes[position], position + offset);
                    position = position + offset;
                }
                this.customPositionsByImageCodes.set(customSortedImageCodes[oldPosition], newPosition);
            }
        });
        Object.defineProperty(this, "removeImageCodePosition", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (imageCode) => {
                this.customPositionsByImageCodes.delete(imageCode);
            }
        });
        makeObservable(this);
        this.exportConfigsStore = exportConfigsStore;
        reaction(() => exportConfigsStore.exportConfigs, () => {
            this.isGeneral = true;
        });
        reaction(() => this.isGeneral, (isGeneral) => {
            if (isGeneral) {
                this.imageType = 'default';
                this.watermark = false;
            }
        });
        reaction(() => this.imageType, (imageType) => {
            if (imageType === 'custom') {
                if (this.isGeneral) {
                    this.isGeneral = false;
                }
                if (this.watermarkImages.length > 0) {
                    this.watermark = true;
                }
            }
        });
        reaction(() => this.watermark, (watermark) => {
            if (!watermark && this.watermarkImage) {
                this.removeImage(this.watermarkImage);
            }
            if (watermark && this.isGeneral) {
                this.isGeneral = false;
            }
        });
        reaction(() => this.exportConfig, (exportConfig) => {
            if (exportConfig) {
                this.wallImage = exportConfig.wallImage;
                this.floorImage = exportConfig.floorImage;
                this.watermarkImage = exportConfig.watermarkImage;
                this.autoDeWatermarkImage = exportConfig.autoDeWatermarkImage;
            }
            else {
                this.watermarkImage = null;
                this.autoDeWatermarkImage = null;
                this.wallImage = this.exportBackgroundImages.find(({ type, appointment }) => {
                    return type === 'default' && appointment === 'wall';
                });
                this.floorImage = this.exportBackgroundImages.find(({ type, appointment }) => {
                    return type === 'default' && appointment === 'floor';
                });
            }
        });
        reaction(() => this.imageCodes, (imageCodes) => {
            this.imageCodesByCategories.clear();
            this.customPositionsByImageCodes.clear();
            if (imageCodes) {
                imageCodes.forEach((imageCode) => {
                    if (!isDefaultPosition(imageCode)) {
                        const { image_code, position } = imageCode;
                        const defaultImageCode = DEFAULT_IMAGE_CODES.find((defaultImageCode) => {
                            return defaultImageCode.image_code === image_code;
                        });
                        this.customPositionsByImageCodes.set(defaultImageCode, position);
                    }
                });
            }
        }, {
            fireImmediately: true
        });
    }
    get isGeneral() {
        return !this.exportConfig;
    }
    set isGeneral(isGeneral) {
        if (isGeneral) {
            this.exportConfig = null;
        }
        else {
            const { exportConfigs } = this.exportConfigsStore;
            if (exportConfigs.length > 0) {
                this.exportConfig = exportConfigs[0];
            }
        }
    }
    get autoDeWatermark() {
        return this.autoDeWatermarkImage !== null && this.autoDeWatermarkImage !== undefined;
    }
    set autoDeWatermark(autoDeWatermark) {
        if (autoDeWatermark) {
            this.autoDeWatermarkImage = this.autoDeWatermarkImages[0];
        }
        else {
            this.autoDeWatermarkImage = null;
        }
    }
    get wallImages() {
        return this.exportBackgroundImages.filter(({ type, appointment }) => {
            return type === this.imageType && appointment === 'wall';
        });
    }
    get floorImages() {
        return this.exportBackgroundImages.filter(({ type, appointment }) => {
            return type === this.imageType && appointment === 'floor';
        });
    }
    get watermarkImages() {
        return this.exportBackgroundImages.filter(({ type, appointment }) => {
            return type === this.imageType && appointment === 'watermark';
        });
    }
    get autoDeWatermarkImages() {
        return this.exportBackgroundImages.filter(({ appointment }) => {
            return appointment === 'auto_de_watermark';
        });
    }
    get advertisingImages() {
        if (this.exportConfig) {
            const { advertisingImages } = this.exportConfig;
            if (advertisingImages) {
                return advertisingImages;
            }
        }
        return [];
    }
    get imageCodes() {
        if (this.exportConfig) {
            const { imageCodes } = this.exportConfig;
            if (imageCodes) {
                return imageCodes.sort((a, b) => {
                    return a.position - b.position;
                });
            }
        }
        return observable(DEFAULT_IMAGE_CODES);
    }
    get customSortedImageCodes() {
        const customSortedImageCodes = observable.array([], { deep: false });
        customSortedImageCodes.replace(DEFAULT_IMAGE_CODES.filter(imageCode => !this.customPositionsByImageCodes.has(imageCode)));
        const entries = Array.from(this.customPositionsByImageCodes.entries());
        const sortedEntries = entries.sort((a, b) => a[1] - b[1]);
        sortedEntries.forEach(([imageCode, position]) => {
            customSortedImageCodes.splice(position, 0, imageCode);
        });
        return customSortedImageCodes;
    }
    get imageCodesByCategories() {
        const imageCodesByCategories = observable.map([], { deep: false });
        DEFAULT_IMAGE_CODES.forEach((imageCode) => {
            const { category } = imageCode;
            if (!imageCodesByCategories.has(category)) {
                imageCodesByCategories.set(category, []);
            }
            imageCodesByCategories.get(category).push(imageCode);
        });
        return imageCodesByCategories;
    }
    get exportBackgroundImages() {
        const { exportConfigs } = this.exportConfigsStore;
        let exportConfig;
        if (this.exportConfig) {
            exportConfig = this.exportConfig;
        }
        else if (exportConfigs.length > 0) {
            exportConfig = exportConfigs[0];
        }
        else {
            return [];
        }
        return exportConfig.exportBackgroundImages;
    }
}
__decorate([
    observable,
    __metadata("design:type", typeof (_a = typeof ExportConfig !== "undefined" && ExportConfig) === "function" ? _a : Object)
], ExportConfigEditorStore.prototype, "exportConfig", void 0);
__decorate([
    observable,
    __metadata("design:type", typeof (_b = typeof BackgroundImage !== "undefined" && BackgroundImage) === "function" ? _b : Object)
], ExportConfigEditorStore.prototype, "wallImage", void 0);
__decorate([
    observable,
    __metadata("design:type", typeof (_c = typeof BackgroundImage !== "undefined" && BackgroundImage) === "function" ? _c : Object)
], ExportConfigEditorStore.prototype, "floorImage", void 0);
__decorate([
    observable,
    __metadata("design:type", typeof (_d = typeof BackgroundImage !== "undefined" && BackgroundImage) === "function" ? _d : Object)
], ExportConfigEditorStore.prototype, "watermarkImage", void 0);
__decorate([
    observable,
    __metadata("design:type", typeof (_e = typeof BackgroundImage !== "undefined" && BackgroundImage) === "function" ? _e : Object)
], ExportConfigEditorStore.prototype, "autoDeWatermarkImage", void 0);
__decorate([
    observable,
    __metadata("design:type", typeof (_f = typeof BackgroundImageType !== "undefined" && BackgroundImageType) === "function" ? _f : Object)
], ExportConfigEditorStore.prototype, "imageType", void 0);
__decorate([
    observable,
    __metadata("design:type", Boolean)
], ExportConfigEditorStore.prototype, "isDefaultOrder", void 0);
__decorate([
    observable,
    __metadata("design:type", Boolean)
], ExportConfigEditorStore.prototype, "watermark", void 0);
__decorate([
    observable,
    __metadata("design:type", typeof (_g = typeof ObservableMap !== "undefined" && ObservableMap) === "function" ? _g : Object)
], ExportConfigEditorStore.prototype, "customPositionsByImageCodes", void 0);
__decorate([
    action,
    __metadata("design:type", Object)
], ExportConfigEditorStore.prototype, "setExportConfig", void 0);
__decorate([
    action,
    __metadata("design:type", Object)
], ExportConfigEditorStore.prototype, "setGeneral", void 0);
__decorate([
    action,
    __metadata("design:type", Object)
], ExportConfigEditorStore.prototype, "setDefaultOrder", void 0);
__decorate([
    action,
    __metadata("design:type", Object)
], ExportConfigEditorStore.prototype, "setWatermark", void 0);
__decorate([
    action,
    __metadata("design:type", Object)
], ExportConfigEditorStore.prototype, "setAutoDeWatermark", void 0);
__decorate([
    action,
    __metadata("design:type", Object)
], ExportConfigEditorStore.prototype, "setImageType", void 0);
__decorate([
    action,
    __metadata("design:type", Object)
], ExportConfigEditorStore.prototype, "setImage", void 0);
__decorate([
    action,
    __metadata("design:type", Object)
], ExportConfigEditorStore.prototype, "removeImage", void 0);
__decorate([
    action,
    __metadata("design:type", Object)
], ExportConfigEditorStore.prototype, "addImageCodePosition", void 0);
__decorate([
    action,
    __metadata("design:type", Object)
], ExportConfigEditorStore.prototype, "replaceImageCodePosition", void 0);
__decorate([
    action,
    __metadata("design:type", Object)
], ExportConfigEditorStore.prototype, "removeImageCodePosition", void 0);
__decorate([
    computed,
    __metadata("design:type", Boolean),
    __metadata("design:paramtypes", [Boolean])
], ExportConfigEditorStore.prototype, "isGeneral", null);
__decorate([
    computed,
    __metadata("design:type", Boolean),
    __metadata("design:paramtypes", [Boolean])
], ExportConfigEditorStore.prototype, "autoDeWatermark", null);
__decorate([
    computed,
    __metadata("design:type", Array),
    __metadata("design:paramtypes", [])
], ExportConfigEditorStore.prototype, "wallImages", null);
__decorate([
    computed,
    __metadata("design:type", Array),
    __metadata("design:paramtypes", [])
], ExportConfigEditorStore.prototype, "floorImages", null);
__decorate([
    computed,
    __metadata("design:type", Array),
    __metadata("design:paramtypes", [])
], ExportConfigEditorStore.prototype, "watermarkImages", null);
__decorate([
    computed,
    __metadata("design:type", Array),
    __metadata("design:paramtypes", [])
], ExportConfigEditorStore.prototype, "autoDeWatermarkImages", null);
__decorate([
    computed,
    __metadata("design:type", Array),
    __metadata("design:paramtypes", [])
], ExportConfigEditorStore.prototype, "advertisingImages", null);
__decorate([
    computed,
    __metadata("design:type", Array),
    __metadata("design:paramtypes", [])
], ExportConfigEditorStore.prototype, "imageCodes", null);
__decorate([
    computed,
    __metadata("design:type", Array),
    __metadata("design:paramtypes", [])
], ExportConfigEditorStore.prototype, "customSortedImageCodes", null);
__decorate([
    computed,
    __metadata("design:type", typeof (_h = typeof Map !== "undefined" && Map) === "function" ? _h : Object),
    __metadata("design:paramtypes", [])
], ExportConfigEditorStore.prototype, "imageCodesByCategories", null);
__decorate([
    computed,
    __metadata("design:type", Array),
    __metadata("design:paramtypes", [])
], ExportConfigEditorStore.prototype, "exportBackgroundImages", null);
export default new ExportConfigEditorStore(exportConfigsStore);
